import { RouteRecordRaw } from "vue-router";

export const projectListRoute: RouteRecordRaw = {
  path: "/projects",
  name: "PROJECT_LIST",
  component: () => import("@/pages/project/Page.vue"),
  meta: {
    title: "project list",
    activeLinkGroup: "PROJECTS",
    sort: 1,
    sidebar: {
      icon: "person",
      label: "Проекты",
    },
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "PROJECT_LIST");
    },
  },
};

export const projectCreateRoute: RouteRecordRaw = {
  path: "/projects/create",
  name: "PROJECT_CREATE",
  component: () => import("@/pages/project/Create.vue"),
  meta: {
    title: "project create",
    activeLinkGroup: "PROJECTS",
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "PROJECT_CREATE");
    },
  },
};

export const projectEditRoute: RouteRecordRaw = {
  path: "/projects/edit/:id",
  props: true,
  name: "PROJECT_EDIT",
  component: () => import("@/pages/project/Edit.vue"),
  meta: {
    title: "project edit",
    activeLinkGroup: "PROJECTS",
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "PROJECT_EDIT");
    },
  },
};

export const projectSchemaRoute: RouteRecordRaw = {
  path: "/scheme/:id",
  props: true,
  name: "SCHEME_EDIT",
  component: () => import("@/pages/project/Scheme.vue"),
  meta: {
    title: "scheme edit",
    activeLinkGroup: "PROJECTS",
    accsess: async (permissions: string[]) => {
      return permissions.some((p) => p === "SCHEME_EDIT");
    },
  },
};
